import React, {useContext, useState} from "react"
import PropTypes from "prop-types"
import FilterDropdownItem from "./FilterDropdownItem"
import {ChevronDown, ChevronUp} from "react-bootstrap-icons"
import {useRouter} from "next/router"
import {FilterProps} from "./props/FilterProps"
import Typography from "../../reusable/Typography/Typography"
import LayoutContext from "../../../context/LayoutContext"
import DataContext from "../../../context/DataContext"
import ReusableRangeFilter from "../ReusableRangeFilter"

const FilterDropdown: React.FC<FilterProps> = ({
	label,
	param,
	options,
	collectionName,
	customUrlBaseValue
}) => {
	const [onOff, setOnOff] = useState(false)
	const {isMobile} = useContext(LayoutContext)
	const router = useRouter()
	const params = router.query
	const isSelected = params[param] && params[param] !== "-" && params[param] !== undefined
	const {pageProps} = useContext(DataContext)
	const {sliderFilters} = pageProps
	const [sliderFilterRanges, setSliderFilterRanges] = useState(() => {
		const filter = sliderFilters?.find(filter => filter.slug === param)

		if (!filter) {
			return null
		}

		return {...filter, value: [filter.min, filter.max]}
	})
	const firstOption = options?.[0]
	const unit = firstOption?.name?.split(" ")?.[firstOption?.name?.split(" ").length - 1]?.toLowerCase()
	return (
		<>
			<div className="accordion">
				<div className="d-grid">
					<button onClick={() => {
						setOnOff(prevState => !prevState)
					}}
					className={`btn py-3 shadow-none px-0 rounded-0 ${onOff ? "show" : ""}`}
					type="button"
					data-bs-toggle="dropdown"
					aria-expanded={onOff ? "true" : "false"}>
						<div className={"row  d-md-flex g-0"}>
							<Typography variant={isSelected ? "bodyLgBold" : "bodyLg"}
								semanticTag="div"
								className={"col text-start"}>
								{label} {!isNaN(sliderFilterRanges?.max || "a") ? `(${unit})` : ""}
							</Typography>
							<div className={"col-auto"}>
								{onOff ? <ChevronUp/> : <ChevronDown/>}
							</div>
						</div>
					</button>
				</div>
				<div className={`accordion-collapse collapse ${onOff ? "show" : null}`}>
					<div className="pb-2 bg-white w-100 border-0 rounded-0">
						{sliderFilterRanges !== null ? <div
							className="px-0">
							{!isNaN(sliderFilterRanges?.max) && !isNaN(sliderFilterRanges?.min) ? <div className={"col-12"}>
								<ReusableRangeFilter
									shouldUseZero
									collectionName={collectionName}
									param={param}
									value={sliderFilterRanges}
									setValue={setSliderFilterRanges}
								/>
							</div> : null}
						</div> : label === "categories" && isMobile ? <div className="px-0  d-md-flex justify-content-center"
							style={{width: "100%", overflowX: "scroll"}}>
							<ul className="px-0 d-flex align-items-center list-unstyled bike-tabs"
								style={{marginBottom: 0}}>
								{options?.map(category =>
									<div key={category.slug}
										className="col-auto">
										<FilterDropdownItem key={category.slug}
											isBoxShape={true}
											label={category.name}
											collectionName={collectionName}
											param={param}
											value={category.slug}/>
									</div>
								)}
							</ul>
						</div> :
							<>
								{options?.map(option => {
									// Check if option has parent that is other option
									const {id, name, slug, parentId} = option
									const children = options.filter(opt => opt.parentId === option.id)

									const isParent = Boolean(children.length)
									const isChild = options?.find(opt => opt.id === parentId)

									return (!isChild &&
										<React.Fragment key={id + slug}>
											<FilterDropdownItem customUrlBaseValue={customUrlBaseValue}
												collectionName={collectionName}
												label={name}
												param={param}
												value={slug}/>
											{isParent && <div className={"ps-4"}>
												{children.map(child => {
													const _children = options.filter(opt => opt.parentId === child.id)
													return <React.Fragment key={child.id}>
														<FilterDropdownItem customUrlBaseValue={customUrlBaseValue}
															collectionName={collectionName}
															key={child.id}
															label={child.name}
															param={param}
															value={child.slug}/>
														{_children && <div className={"ps-3"}>
															{_children.map(_child => {
																return <FilterDropdownItem customUrlBaseValue={customUrlBaseValue}
																	collectionName={collectionName}
																	key={_child.id}
																	label={_child.name}
																	param={param}
																	value={_child.slug}/>
															})}
														</div>}
													</React.Fragment>
												})}
											</div>
											}
										</React.Fragment>
									)
								})}
							</>}
					</div>
				</div>
			</div>
		</>
	)
}

FilterDropdown.propTypes = {
	label: PropTypes.string.isRequired,
	param: PropTypes.string.isRequired,
	options: PropTypes.array.isRequired,
	children: PropTypes.node
}

export default FilterDropdown
